module.exports = __webpack_public_path__ + "img/chevron.da2990c6.svg";